import { Col, Row } from "react-bootstrap";
import Button from "@mui/material/Button";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import React from "react";
import { useTranslation } from "react-i18next";

interface UserManageHeaderToolbarProps {
  onAddClaimClick?: () => void;
}

export function UserManageHeaderToolbar(props: UserManageHeaderToolbarProps) {
  const { t } = useTranslation();

  return (
    <Row>
      <Col>
        <Button
          variant="contained"
          color="primary"
          onClick={props.onAddClaimClick}
          startIcon={<FontAwesomeIcon style={{ cursor: "pointer" }} icon={faPlus} />}
        >
          {t("userManagement.addClaim")}
        </Button>
      </Col>
    </Row>
  );
}
